import { OurStoryPage } from '../components/OurStoryPage';
import { useNavigate } from 'react-router-dom';

export function AboutPage() {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <OurStoryPage onNavigateHome={handleNavigateHome} />
  );
}
